import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "okHand"
const OkHandIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.57 15.338a8.209 8.209 0 0 0 2.195-1.285c.237.264.496.528.764.77.41.37.797.652 1.122.809.173.083.302.118.373.118.979 0 2.226-.997 2.226-1.75 0-.463-.405-1.308-1.056-2.163a7.908 7.908 0 0 0-.938-1.036 6.532 6.532 0 0 0-.762.29c-.182.082-.375.174-.575.275a19.674 19.674 0 0 0-1.266.7 1.25 1.25 0 0 1-1.306-2.132 22.198 22.198 0 0 1 1.446-.8c.234-.118.463-.228.684-.326.799-.356 1.45-.558 2.023-.558.588 0 1.372.561 2.106 1.372l-.578-1.473-2.661-3.87a1.375 1.375 0 1 1 2.266-1.558l2.84 4.13.732 1.864-.186-1.485-.732-2.927a1.25 1.25 0 1 1 2.426-.606l.75 3 .027.148.277 2.21C16.902 8.352 17 7.626 17 7v-.002c0-.551.444-.998 1-.998.552 0 1 .443 1 .999V9c0 9.5-2.242 12.564-2.242 12.564-.137.245-.481.436-.756.436h-4.385c-1.578 0-5.023-3.253-7.047-6.662Z"
      />
    </svg>
  )
}
export default OkHandIcon
